var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpotify = function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18M5.792 7.908A9.6 9.6 0 0 1 9.55 7.15c2.016 0 3.884.616 5.427 1.67a.75.75 0 1 0 .846-1.24A11.1 11.1 0 0 0 9.55 5.65c-1.54 0-3.007.312-4.342.877a.75.75 0 0 0 .584 1.381m.396 2.865A9.1 9.1 0 0 1 9.1 10.3c1.685 0 3.26.454 4.615 1.247a.75.75 0 1 0 .758-1.294A10.6 10.6 0 0 0 9.1 8.8a10.6 10.6 0 0 0-3.388.55.75.75 0 1 0 .476 1.423m.978 2.934a7.4 7.4 0 0 1 1.936-.257c1.216 0 2.361.295 3.37.816a.75.75 0 0 0 .689-1.332 8.8 8.8 0 0 0-4.06-.984c-.804 0-1.585.108-2.328.31a.75.75 0 0 0 .393 1.447",
    clipRule: "evenodd"
  })));
};
export default SvgSpotify;